// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_UST","cls2":"ImpactHubModal-cls2_LWZ ImpactHubModal-cls1_UST"};